const OPERATION_DEFINITION = 'OperationDefinition';

const getQueryName = (query) => {
    const defs = query.definitions;
    /* istanbul ignore else */
    if (defs && defs.length) {
        const operationDefinition = defs.filter(
            ({kind}) => kind === OPERATION_DEFINITION
        );
        return (
            operationDefinition.length &&
            operationDefinition[0].name &&
            operationDefinition[0].name.value
        );
    }
    /* istanbul ignore next */
    return null;
};

module.exports = {
    getQueryName
};
